<template>
  <router-link :to="link" class="hover-outline line-height-4">#{{ name }}</router-link>
</template>

<script>
  export default {
    name: 'TagItem',
    props: {
      tag: {
        type: Object,
        required: true
      }
    },
    computed: {
      type () {
        return this.tag.post_type || this.tag.type || this.tag.taxonomy
      },
      id () {
        return this.tag.ID || this.tag.id || this.tag.term_id
      },
      name () {
        return this.tag.post_title || this.tag.name || this.tag.title
      },
      link () {
        if (!this.id || !this.name) return '/'

        return `?tagtype=${this.type}&name=${encodeURIComponent(this.name)}&id=${this.id}`
      }
    }
  }
</script>

<style>
  .hover-outline {
    border: 1px dotted transparent;
    border-radius: 3px;
    padding: 0 2px;
    margin: 0 -2px;
  }
  .hover-outline:hover {
    border-color: currentColor;
  }
</style>
